import React, {Component} from 'react';
import styles from './styles.css';

export default class Select extends Component {
	render() {
		return (
			<div className={styles['bsui-select']}>
				<select {...this.props} className={styles['bsui-select__control']}>{this.props.children}</select>
			</div>
		);
	}
}